module.exports = __webpack_public_path__ + "static/img/g-money.a111bc0.png";